import { FC } from 'react';

import Dropdown from '@components/Dropdown';
import { DropdownSelectProps } from '@components/Dropdown/DropdownInterface';

interface IPassengerTypeOption {
  key: string;
  label: string;
}

export const PASSENGER_TYPE_OPTIONS: IPassengerTypeOption[] = [
  { key: 'ADT', label: 'Yetişkin' },
  { key: 'CHD', label: 'Çocuk' },
  { key: 'INF', label: 'Bebek' },
];

export type IDropdownsPassengerType = DropdownSelectProps<IPassengerTypeOption>;

const PassengerType: FC<IDropdownsPassengerType> = ({
  onChange = () => null,
  ...rest
}) => {
  return (
    <Dropdown
      items={PASSENGER_TYPE_OPTIONS}
      renderLabel={(p) => (!p ? 'Yolcu Tipi' : p.label)}
      renderOption={(p) => p.label}
      optionsZIndex={6}
      onChange={(type) =>
        onChange((type.key ?? '') as unknown as IPassengerTypeOption)
      }
      {...rest}
    />
  );
};

export default PassengerType;
